export default {
  eyebrow: '404 | Off-track',
  title: 'This page drifted out of orbit',
  description:
    'The address you tried to reach is not here anymore. You can head back to the homepage or return to where you were.',
  actions: {
    home: 'Back to homepage',
    back: 'Previous page',
  },
};
